(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fraela-color-quiz"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fraela-color-quiz]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const intro = root.querySelector('[data-quiz-intro]');
    const body = root.querySelector('[data-quiz-body]');
    const result = root.querySelector('[data-quiz-result]');
    const questions = [...root.querySelectorAll('[data-question]')];
    const progress = root.querySelector('[data-progress]');
    const currentStep = root.querySelector('[data-current-step]');
    const next = root.querySelector('[data-quiz-next]');
    const back = root.querySelector('[data-quiz-back]');
    const validation = root.querySelector('[data-validation]');
    let step = 0;

    const seasons = {
      spring: { title:'JARNÉMU TYPU', short:'JAR', traits:'Teplá · svieža · jasná', copy:'Vaše prirodzené sfarbenie pravdepodobne podporia teplé, svieže a jasnejšie odtiene, ktoré mu dodajú ľahkosť a žiarivosť.', link:'/collections/odtiene-pre-jarne-typy', detail:'/pages/jarny-typ-farebna-typologia', colors:['#f0b77d','#e67f71','#d7a056','#b9cb75','#df6674'] },
      summer: { title:'LETNÉMU TYPU', short:'LETO', traits:'Studená · jemná · tlmená', copy:'Vašej prirodzenej farebnosti budú pravdepodobne lichotiť jemnejšie, chladnejšie a menej kontrastné odtiene.', link:'/collections/odtiene-pre-letne-typy', detail:'/pages/letny-typ-farebna-typologia', colors:['#d4a3ae','#b98599','#a995c5','#9ebbd0','#9b7189'] },
      autumn: { title:'JESENNÉMU TYPU', short:'JESEŇ', traits:'Teplá · jemná · tlmená', copy:'Vaše prirodzené sfarbenie pravdepodobne najkrajšie podporia teplé, zemité a tlmenejšie odtiene s prirodzenou hĺbkou.', link:'/collections/odtiene-pre-jesenne-typy', detail:'/pages/jesenny-typ-farebna-typologia', colors:['#c88c55','#b96e35','#9b513c','#70754b','#7d4937'] },
      winter: { title:'ZIMNÉMU TYPU', short:'ZIMA', traits:'Studená · výrazná · kontrastná', copy:'Vašu prirodzenú výraznosť pravdepodobne podporia čisté, chladné a kontrastné odtiene, ktoré sa nestratia pri vašich črtách.', link:'/collections/odtiene-pre-zimne-typy', detail:'/pages/zimny-typ-farebna-typologia', colors:['#d85878','#bd2851','#741f3f','#214d9b','#7f315f'] }
    };

    function showStep(index) {
      step = index;
      questions.forEach((question, i) => { question.hidden = i !== step; });
      currentStep.textContent = String(step + 1);
      progress.style.width = `${((step + 1) / questions.length) * 100}%`;
      back.style.visibility = 'visible';
      next.firstChild.textContent = step === questions.length - 1 ? 'Zistiť výsledok ' : 'Ďalej ';
      next.classList.toggle('fq__button--finish', step === questions.length - 1);
      validation.hidden = true;
      questions[step].querySelector('legend').focus({preventScroll:true});
      body.scrollIntoView({behavior:'instant',block:'start'});
    }

    function startQuiz() {
      intro.hidden = true;
      result.hidden = true;
      body.hidden = false;
      showStep(0);
      body.scrollIntoView({ behavior:'smooth', block:'start' });
    }

    function restartQuiz() {
      root.querySelector('form').reset();
      startQuiz();
    }

    function calculate() {
      const scores = { warm:0, cool:0, bright:0, muted:0 };
      root.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
        if (input.value === 'neutral') return;
        input.value.split(',').forEach((part) => {
          const [axis, points] = part.split(':');
          scores[axis] += Number(points);
        });
      });
      const ranked = [
        ['spring', scores.warm + scores.bright],
        ['summer', scores.cool + scores.muted],
        ['autumn', scores.warm + scores.muted],
        ['winter', scores.cool + scores.bright]
      ].sort((a,b) => b[1] - a[1]);
      renderResult(ranked[0][0], ranked[1][0], ranked[0][1] - ranked[1][1]);
    }

    function renderResult(primaryKey, secondaryKey, margin) {
      const primary = seasons[primaryKey];
      const secondary = seasons[secondaryKey];
      root.querySelector('[data-result-title]').textContent = primary.short;
      root.querySelector('[data-result-traits]').textContent = primary.traits;
      root.querySelector('[data-result-copy]').textContent = primary.copy;
      root.querySelector('[data-secondary-title]').textContent = secondary.short;
      root.querySelector('[data-secondary-copy]').textContent = margin <= 1 ? `Výsledok je tesný. Môžete byť na pomedzí typov ${primary.short} a ${secondary.short}.` : `Niektoré vaše znaky sa približujú aj typu ${secondary.short}.`;
      root.querySelector('[data-result-link]').href = primary.link;
      root.querySelector('[data-secondary-link]').href = secondary.detail;
      root.querySelector('[data-result-swatches]').innerHTML = primary.colors.map((color) => `<i style="--c:${color}"></i>`).join('');
      body.hidden = true;
      result.hidden = false;
      result.scrollIntoView({ behavior:'smooth', block:'start' });
    }

    root.querySelector('[data-quiz-start]').addEventListener('click', startQuiz);
    root.querySelectorAll('[data-quiz-restart]').forEach((button) => button.addEventListener('click', restartQuiz));
    next.addEventListener('click', () => {
      const selected = questions[step].querySelector('input:checked');
      if (!selected) { validation.hidden = false; return; }
      if (step < questions.length - 1) showStep(step + 1); else calculate();
    });
    back.addEventListener('click', () => { if (step > 0) showStep(step - 1); else { body.hidden = true; intro.hidden = false; root.scrollIntoView({behavior:'instant',block:'start'}); } });
    root.querySelector('form').addEventListener('submit', event => event.preventDefault());
    root.querySelectorAll('input[type="radio"]').forEach((input) => input.addEventListener('change', () => { validation.hidden = true; }));
  });

  } catch(e) { console.error(e); }
})();
})();
